<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
	<div class="supplier-settings md-grey-page">
		<section class="edit-page container">
			<h2 class="text-center">Supplier Settings</h2>
			<div class="mdc-layout-grid">
				<div class="mdc-layout-grid__inner edit-page__inner">

					<div class="edit-page__content mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
						<!-- Supplier main settings -->
						<div class="mdc-layout-grid__inner editable-item">
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-tablet editable-item__title">
								<div class="supplier-settings__logo" style="background-image: url('/static/img/supplier_logo_sample.png');">
										<a href="#" style="position: absolute; bottom: 5px; right: 5px;"><i class="ico-edit"></i></a>
								</div>
							</div>
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-4-tablet">
								<span class="supplier-settings__name">{{supplier.name}}</span> <a href="#"><i class="ico-edit"></i></a>
								<p>{{supplier.description}} <a href="#"><i class="ico-edit"></i></a></p>
							</div>

							<!-- Divider -->
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
								<hr>
							</div>
					  	</div>

						<!-- Authentication method -->
						<!-- <div class="mdc-layout-grid__inner editable-item">
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-tablet editable-item__title">
								<div class="editable-item__centered"><span>Authentication</span></div>
							</div>
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-4-tablet website-edit__custom-domain__body">
								<select>
									<option>No Authentication</option>
									<option selected="selected">API Keys</option>
									<option>Basic Authentication</option>
									<option>Session-based Authentication</option>
									<option>OAuthV2</option>
								</select>
							<a href="#"><i class="ico-edit"></i></a></p>
							</div>

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
								<hr>
							</div>
						</div> -->

						<editable-item v-model="supplier.authentication" component="editable-options" title="Authentication" :options="{items: [['no-authentication', 'No Authentication'],['api-keys', 'API Keys'],['basic-authentication', 'Basic Authentication'],['session-based-authentication', 'Session-based Authentication'],['oauthv2', 'OAuthV2']], large: true}"
						@isEditView="editView(arguments[0])" @changed="" @back=""></editable-item>

						<!-- Bestagent Triggers -->
						<div class="mdc-layout-grid__inner editable-item supplier-settings__triggers">
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-tablet editable-item__title supplier-settings__label">
								<div class="editable-item__centered">
									<span>BestAgent Triggers </span><span style="font-size: 14px;">(receive data from BestAgent)</span>
									<div class="supplier-settings__triggers__add-btn text-center">
										<a href="#" @click.prevent="$router.push('/supplier/trigger')" class="mdc-button mdc-button--raised">Add BestAgent Trigger</a>
									</div>
								</div>
							</div>

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8 mdc-layout-grid__cell--span-4-tablet table-triggers">
								<div class="mdc-layout-grid__inner mq-md-hidden supplier-settings__trigger__titles">
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone">
										Event
									</div>
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone">
										Endpoint
									</div>
								</div>

								<div v-for="trigger in supplier.ba_triggers" class="mdc-layout-grid__inner supplier-settings__trigger">
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone supplier-settings__trigger-event">
										{{trigger.event}}
									</div>
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone supplier-settings__trigger-endpoint">
										{{trigger.endpoint}}
									</div>
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-1 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone editable-item__edit-btn supplier-settings__trigger-edit">
										<a href="#" @click.prevent=""><i class="ico ico-edit"></i></a>
									</div>
								</div>

							</div>

							<!-- Divider -->
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
								<hr>
							</div>
						</div>


						<!-- BestAgent Actions -->
						<div class="mdc-layout-grid__inner editable-item">
							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-2-tablet editable-item__title supplier-settings__label">
								<div class="editable-item__centered">
									<span>BestAgent Actions </span><span style="font-size: 14px;">(send your data to BestAgent)</span>
									<div class="supplier-settings__triggers__add-btn text-center">
										<a href="#" @click.prevent="$router.push('/supplier/action')" class="mdc-button mdc-button--raised">Add BestAgent Action</a>
									</div>
								</div>


							</div>

							<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8 mdc-layout-grid__cell--span-4-tablet table-triggers">

								<div class="mdc-layout-grid__inner mq-md-hidden supplier-settings__trigger__titles">
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone">
										Endpoint
									</div>
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-5 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone">
										Action
									</div>
								</div>

								<div v-for="trigger in supplier.supplier_triggers" class="mdc-layout-grid__inner supplier-settings__trigger">
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-7 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone supplier-settings__trigger-endpoint">
										{{trigger.endpoint}}
									</div>
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-4 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone supplier-settings__trigger-event">
										{{trigger.action}}
									</div>
									<div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-1 mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-12-phone editable-item__edit-btn supplier-settings__trigger-edit">
										<a href="#" @click.prevent=""><i class="ico ico-edit"></i></a>
									</div>
								</div>

							</div>

						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>


<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import EditableItem 	from '../components/editable-items/EditableItem.vue';

export default {
	data: function() {
		return {
			supplier: {
				name: 'Good Leads',
				description: 'All the best leads for your business.',
				logo: '',
				authentication: 'api-keys',
				ba_triggers: [
					{ event: 'Property added', endpoint: 'https://api.goodleads.com/v1/properties' },
					{ event: 'Property sold', endpoint: 'https://api.goodleads.com/v1/properties/status' },
					{ event: 'Price changed', endpoint: 'https://api.goodleads.com/v1/properties/price' },
				],
				supplier_triggers: [
					{ endpoint: 'https://api.goodleads.com/webhooks', action: 'Add Property' },
					{ endpoint: 'https://api.goodleads.com/webhooks', action: 'Add Applicant' },
					{ endpoint: 'https://api.goodleads.com/webhooks', action: 'Change property status' },
				]
			}
		}
	},
	components: {
		'editable-item': EditableItem
	},
	created: async function() {
	},
	computed: {
	},
	methods: {
	}
}
</script>

<style>
.table-triggers {
	width: 100%;
}

.table-triggers th {
	text-align: left;
}

.table-triggers--event {
	color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/Supplier.vue